import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getT } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("metazik_lang") || "fr";
    } catch (e) {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("metazik_lang", lang);
    } catch (e) {
      // ignore
    }
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: getT(lang) }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
